import type { FC } from 'react';
import { Flex, Typography } from '@ui';
import { useTranslation } from 'react-i18next';
import { RegionMetrics } from '@/components/RegionMetrics/RegionMetrics';
import { Tower } from '@/components/Tower/Tower';
import { Weather } from '@/components/Weather/Weather';
import styles from './TowerStatsSection.module.css';

export const TowerStatsSection: FC = () => {
    const { t } = useTranslation();

    return (
        <Flex vertical>
            <Tower />
            <div className={styles.titleWrapper}>
                <Typography.Display level={1} color="textPrimary">{t('Tower_Title')}</Typography.Display>
            </div>
            <Flex className={styles.metricsWeatherWrapper}>
                <RegionMetrics />
                <Flex flex="0 0 50%" justify="center" className={styles.weatherWrapper}>
                    <Weather section />
                </Flex>
            </Flex>
        </Flex>
    );
};
